export const BANK_LIST_REQUEST = 'BANK_LIST_REQUEST';
export const BANK_LIST_REQUEST_SUCCESS = 'BANK_LIST_REQUEST_SUCCESS';
export const BANK_LIST_REQUEST_ERROR = 'BANK_LIST_REQUEST_ERROR';
